import Coupons from "../../components/Coupon/Coupons";
import PageTitleComponent from "../../components/PageTitle";

export default function CouponsScreen(){
return <div>
    <PageTitleComponent title="Coupons" />
    <Coupons/>
</div>
}